import { toast } from "react-toastify";
import { confirmDialog } from "primereact/confirmdialog";
import { createClient, deleteClient, updateClient, getAllClients, getClient } from "../../services/ValitanApiService";

// Fetch Clients
export const getClients = async (page = 0, size = 10) => {
  try {
    const response = await getAllClients(page, size);
    if (response.data.status === "success") {
      const  field = response.data.data;
      // console.log("Clients fetched:", field);
      return {
        clients: field.content,
        paginationInfo: {
          totalElements: field.total_elements,
          totalPages: field.total_pages,
          pageNumber: field.number,
          pageSize: field.size,
          sort: field.sort,
        },
      };
    } else {
      toast.error(response.data.message || "Failed to fetch clients.");
      return { clients: [], paginationInfo: {} };
    }
  } catch (error) {
    // console.error("Error fetching clients:", error);
    toast.error("Error fetching clients. Please try again.");
    return { clients: [], paginationInfo: {} };
  }
};

// Delete Client
export const deleteAClient = async (id, loadClients) => {
  try {
    const response = await deleteClient(id);
    if (response.data.status === "success") {
      toast.success(response.data.message);
      await loadClients();
    } else {
      toast.error(response.data.message || "Failed to delete client.");
    }
  } catch (error) {
    toast.error("Failed to delete client. Please try again.");
    console.error(error);
  }
};

export const confirmDelete = (id, loadClients) => {
  confirmDialog({
    message: "Are you sure you want to delete this client?",
    header: "Confirmation",
    icon: "pi pi-question-circle",
    accept: () => deleteAClient(id, loadClients),
    reject: () => { },
  });
};

// Fetch a single client's details
export const viewClientDetails = async (
    clientId,
    setLoading,
    setClientName,
    setClientTin,
    setClientAddress,
    setClientMobileNumber,
    setClientEmail,
    setClientLogo,
    setClientIsPrivate,
    setClientCreatedAt,
    setModalOpen
) => {
  setLoading(true);

  try {
    const response = await getClient(clientId);

    if (response.data.status === "success" && response.data) {
      const client= response.data.data;
      setClientName(client.name);
      setClientTin(client.tin);
      setClientAddress(client.address);
      setClientMobileNumber(client.mobile_number);
      setClientEmail(client.email);
      setClientLogo(client.logo);
      setClientIsPrivate(client.is_private);
      setClientCreatedAt(client.created_at);
      setModalOpen(true);  // Open the modal once the data is set
    } else {
      console.error(response.message || "Client data is undefined");
      toast.error(response.message || "Error fetching client details.");
    }
  } catch (error) {
    console.error("Error fetching client details:", error);
    toast.error("Error fetching client details. Please try again.");
  } finally {
    setLoading(false); // Stop loading indicator after fetching data
  }
};

// Validation on create or update
export const validateClientForm = (
  clientName,
  clientTin,
  clientMobileNumber,
  clientIsPrivate,
  setErrors
) => {
  let valid = true;
  const errorsCopy = {
    clientName: "",
    clientTin: "",
    clientMobileNumber: "",
    clientIsPrivate: "",
  };

  if (!clientName || clientName.trim() === "") {
    errorsCopy.clientName = "Name is required";
    valid = false;
  }

  if (!clientTin || clientTin.trim() === "") {
    errorsCopy.clientTin = "TIN is required";
    valid = false;
  }

  if (!clientMobileNumber || clientMobileNumber.trim() === "") {
    errorsCopy.clientMobileNumber = "Mobile number is required";
    valid = false;
  }

  if (!clientIsPrivate || clientIsPrivate.trim() === "") {
    errorsCopy.clientIsPrivate = "Ownership type is required";
    valid = false;
  }

  setErrors(errorsCopy);
  return valid;
};


// Create or update client
export const createOrUpdateClient = async (
  event,
  clientName,
  clientTin,
  clientMobileNumber,
  clientAddress,
  clientEmail,
  clientLogo,
  clientIsPrivate,
  editingClientId,
  loadClients,
  toggleModal,
  setErrors
) => {
  event.preventDefault();

  if (!validateClientForm(clientName, clientTin, clientMobileNumber, clientIsPrivate, setErrors)) {
    return;
  }

  // ✅ Convert "Yes"/"No" → Boolean and flip logic (private means not government)
  const isGovernment =
    clientIsPrivate === "Yes"
      ? false   // "Yes" means private
      : clientIsPrivate === "No"
        ? true    // "No" means government
        : false;  // default fallback

  const clientData = {
    name: clientName,
    tin: clientTin,
    address: clientAddress,
    mobile_number: clientMobileNumber,
    email: clientEmail,
    logo: clientLogo,
    is_government: isGovernment, // ✅ correct key name and boolean value
  };

  try {
    const response = editingClientId
      ? await updateClient(editingClientId, clientData)
      : await createClient(clientData);

    // ✅ Safely unwrap the actual backend payload
    const body = response?.data?.data?.body;

    if (body?.status === "success") {
      toast.success(body.message || "Client saved successfully.");
      toggleModal();
      await loadClients();
    } else {
      console.error("Save failed:", body || response.data);
      toast.error(body?.message || "Failed to save client data.");
    }
  } catch (error) {
    console.error("Error saving client data:", error);
    toast.error("Error saving client data. Please try again.");
  }

};
